module.exports = __webpack_public_path__ + "static/img/peach_th.491092f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mixology/cans/peach_th.png
// module id = PNtF
// module chunks = 0